<ol>
  @for (step of steps(); track step.name) {
    @let stepNumber = $index + 1;
    @let status = stepNumber < currentStepNumber() ? 'complete' : stepNumber === currentStepNumber() ? 'current' : 'incomplete';
    <li [attr.data-status]="status" [attr.data-step]="$index">
      <span aria-hidden="true" data-line-circle (click)="step.touchLink?.onClick?.()">
        <span data-line="before"></span>
        <span data-circle>
          <span>{{ stepNumber }}</span>
          @if (status === 'complete') {
            <bspk-icon name="Check" />
          }
        </span>
        <span data-line="after"></span>
      </span>
      <span data-content>
        <span bspk-txt="labels-base" data-name>{{ step.name }}</span>
        @if (step.subtext) {
          <span bspk-txt="body-small" data-subtext>{{ step.subtext }}</span>
        }
      </span>
    </li>
  }
</ol>
